import React, { type FC } from 'react';

import { useTemplateEditorStore } from './store';
import { TagsMenu } from './tags-menu';

export const TemplateSettings: FC = () => {
    const template = useTemplateEditorStore((s) => s.template);
    const setTemplateTags = useTemplateEditorStore((s) => s.setTemplateTags);

    if (!template) throw new Error('Unexpected missing template');

    return (
        <div className="flex flex-col gap-1">
            <p className="text-white text-base font-normal w-full truncate">{template.name}</p>
            <TagsMenu templateId={template.id} tags={template.tags} setTags={setTemplateTags} />
        </div>
    );
};
